export const maxValue = <T extends object>(propName: keyof T, list: T[] = []): number => {
  let value = 0;

  for (const item of list) {
    if (typeof item[propName] === 'number' && item[propName] > value) {
      value = item[propName];
    }
  }

  return value;
};
